import type { ChargebacksAvailability } from "@redotech/redo-onboarding-api/schema/chargebacks/chargebacks-config";
import type {
  AdminConfig,
  DealSizing,
} from "@redotech/redo-onboarding-api/schema/get-progress";
import type { ReturnsAvailability } from "@redotech/redo-onboarding-api/schema/returns/returns-config";
import type { ShippingFulfillmentAvailability } from "@redotech/redo-onboarding-api/schema/shipping-fulfillment/shipping-fulfillment-config";
import type { OrderEditingAvailability } from "@redotech/redo-order-editing-onboarding-common/order-editing-config";
import { createContext, useContext } from "react";

export interface ProductConfig {
  bookingUrl?: string;
  helpBookingUrl?: string;
  chargebacks?: ChargebacksAvailability;
  orderEditing?: OrderEditingAvailability;
  returns?: ReturnsAvailability;
  shippingFulfillment?: ShippingFulfillmentAvailability;
  adminConfig?: AdminConfig;
  dealSizing?: DealSizing;
}

export const ProductConfigContext = createContext<ProductConfig>({});

export function useProductConfig(): ProductConfig {
  return useContext(ProductConfigContext);
}
